import { useState, useEffect } from "react";

import "./App.css";
import AppFrame from "./AppFrame";
import { initAuthenticationWorker } from "./AuthenticationWorker";
import configurationService from "../utility/ConfigurationService";

const App = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      await configurationService.init();
      initAuthenticationWorker();
      setReady(true);
    };

    init();
  }, []);

  if (!ready) {
    return <div>loading...</div>;
  } else {
    return <AppFrame />;
  }
};

export default App;
